import { Request } from '@/classes/Request.ts'

export const csrf = async (): Promise<void> => {
  return new Promise((resolve, reject) => {
    new Request()
      .get('/sanctum/csrf-cookie')
      .then(() => {
        resolve()
      })
      .catch(() => {
        reject()
      })
  })
}
